import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {loadGoogleMaps} from '../../utils/google-maps-loader';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-google-maps-address-complete',
  imports: [],
  templateUrl: './google-maps-address-complete.component.html',
  styleUrl: './google-maps-address-complete.component.css'
})
export class GoogleMapsAddressCompleteComponent implements AfterViewInit {

  @Input() placeholder = 'Start typing address...';
  @Output() addressSelected = new EventEmitter<any>();

  @ViewChild('addressInput') addressInput!: ElementRef<HTMLInputElement>;
  @ViewChild('addressCompleter') addressContainer!: ElementRef<HTMLDivElement>;

  async ngAfterViewInit() {

    await loadGoogleMaps(environment.googleMapsApiKey);

    // import the places library (ensures new API is available)
    await (google.maps.importLibrary("places") as Promise<google.maps.PlacesLibrary>);

    // Create the widget
    const placeAutocomplete = new google.maps.places.PlaceAutocompleteElement({
      // You can provide options here:
      // includedRegionCodes instead of componentRestrictions
      includedRegionCodes: ['US', 'CA', 'MX'],
      // You may not be able to restrict by “types: ['address']” the same way now
      // Optionally, you can bias by location bounds, etc.
    } as any);

    // Append the widget into your container (not overlaying your existing input necessarily)
    this.addressContainer.nativeElement.appendChild(placeAutocomplete);

    // Listen to the new “gmp-select” event
    placeAutocomplete.addEventListener('gmp-select', async (ev: any) => {
      const { placePrediction } = ev;
      const place = placePrediction.toPlace();
      // Now fetch the desired fields
      await place.fetchFields({
        fields: ['addressComponents']
      });

      if (place.addressComponents) {

        const result: any = {};
        for (const comp of place.addressComponents) {

          const type = comp.types[0];
          switch (type) {
            case 'street_number': result.street_number = comp.longText; break;
            case 'route': result.route = comp.shortText; break;
            case 'locality': result.city = comp.shortText; break;
            case 'administrative_area_level_1': result.state = comp.shortText; break;
            case 'postal_code': result.zip = comp.longText; break;
            case 'postal_code_suffix': result.zipPlus4 = comp.longText; break;
            case 'country': result.country = comp.longText; result.countryCode = comp.shortText; break;
          }
        }

        this.addressSelected.emit(result);
      }
    });
  }

}
